import Vue from 'vue'
import Router from 'vue-router'
import homeIndex from '@/page/home/index'
import pageCity from '@/page/city/index'
import searchPage from '@/page/searchPage/index'
import mapPage from '@/page/map/index'
import phoneIndex from '@/Phone/index'
import phoneIndustryIndex from '@/Phone/industry/index'
import phoneCity from '@/Phone/city/index'
import searchIndex from '@/Phone/search/index'
import phoneMapIndex from '@/Phone/map/index'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homeIndex',
      component: homeIndex,
      meta: {
        isLogin: true
      }
    },
    {
      path: '/pageCity',
      name: 'pageCity',
      component: pageCity
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      component: searchPage
    },
    {
      path: '/mapPage',
      name: 'mapPage',
      component: mapPage
    },
    {
      path: '/phoneIndex',
      name: 'phoneIndex',
      component: phoneIndex
    },
    {
      path: '/phoneIndustryIndex',
      name: 'phoneIndustryIndex',
      component: phoneIndustryIndex
    },
    {
      path: '/searchIndex',
      name: 'searchIndex',
      component: searchIndex
    },
    {
      path: '/phoneCity',
      name: 'phoneCity',
      component: phoneCity
    },
    {
      path: '/phoneMapIndex',
      name: 'phoneMapIndex',
      component: phoneMapIndex
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js